// extracted by mini-css-extract-plugin
module.exports = {"QuoteSection":"QuoteSection_QuoteSection__B_BHQ","icon":"QuoteSection_icon__vLrAg"};